import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/EDJR/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/EDJR/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/EDJR/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/industires/slide-1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/industires/slide-2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/industires/slide-3.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/industires/slide-4.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/industires/slide-5.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/monitoring-platform/home_page.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/accessories/cards-accessories-1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/accessories/cards-accessories-2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/differential-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/differential-flow-meter/about-product-differential-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/differential-flow-meter/dfm-cd-defferential-fuel-control.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/differential-flow-meter/differential-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/about-product-flow-meter-heavy-machinery.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/cards/about-product-dfm-marine-brass-body-flange-connections.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/cards/about-product-dfm-marine-brass-body-thread-connections.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/cards/about-product-dfm-marine-duralumin-body-flange-connections.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/cards/about-product-dfm-marine-duralumin-body-thread-connections.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/modals-flow-meter-heavy-machinery-display-only.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-for-heavy-machinery/modals-flow-meter-heavy-machinery-with-cable.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/flow-meter-heavy-machinery.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/fuel-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/fuel-flow-meter/about-product-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/fuel-flow-meter/dfm-displays-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-25can-f.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-25cf.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-7can-f.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-7can-t.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-7cf.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/industrial-flow-meter/cards/dfm-industrial-7ct.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/slider/slider-differential-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/slider/slider-flow-meter-heavy-machinery.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/slider/slider-industries-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/slider/slider-single-chamber-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/slider/slider-wireless-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/wireless-fuel-flow-meter/bluetooth-data-transfer-telematics-unit.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/wireless-fuel-flow-meter/fuel-consumption-control-via-bluetooth-smartphone.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/wireless-fuel-flow-meter/single-chamber-wireless-fuel-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-flow-meters/wireless-fuel-oil-flow-meter.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/differential-fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/differential-fuel-level-sensor/differential-fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor-gps-gsm/about-product.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor/about-product.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor/slider/differential-fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor/slider/fuel-level-sensor-gsm-gps.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor/slider/fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensor/slider/wireless-fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensors-gps-gsm.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/fuel-level-sensors.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/wireless-fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/wireless-fuel-level-sensor/dut-e-s7.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/wireless-fuel-level-sensor/fuel-tank-monitoring-app-driver.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/wireless-fuel-level-sensor/fuel-tank-monitoring-app-features-app.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/fuel-level-sensors/wireless-fuel-level-sensor/fuel-tank-monitoring-app-fleet-manager.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/products-card-1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/products-card-2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/products-card-3.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/products-card-4.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/telematic-gateway/canup-27-pro-lte.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/telematic-gateway/canup-27-pro-wifi.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/telematic-gateway/canup-27-standard.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/telematic-gateway/telematic-gateway-fuel-flow-meters.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/products/telematic-gateway/telematic-gateway-fuel-levol-sensors.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation-services/products/fuel-flowmeters.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation-services/products/fuel-level-sensor.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation-services/products/local-displays-controllers-mob-version.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation-services/products/local-displays-controllers.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation-services/products/telematic-gateway.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/installation.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/monitoring.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/services/warranty-after-sales.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide_1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide_2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide_3.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide_4.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide1_mob.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide2_mob.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide3_mob.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/slider-main/slide4_mob.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser3.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser4.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/solutions-card-1.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/solutions-card-2.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/solutions-card-3.webp");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/assets/images/solutions/solutions-card-4.webp");
;
import(/* webpackMode: "eager", webpackExports: ["ContactUs"] */ "/var/www/EDJR/src/app/[locale]/common/components/ContactUs/ContactUs.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/services/page.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/components/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/components/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/components/Title/Title.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/components/Label/Label.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/common/components/Line/Line.module.scss");
